import { Location } from '.';
import { BaseDataType } from './iti-base-entity';

export type CustomerSubAccount = {
  id: number;
  name: string;
  longName: string;
  contactName: string;
  contactPhoneNumber: string;
  contactMobileNumber: string;
  eMail: string;
  locations: Location[];
  deleted: boolean;
  dateAdded: string; // Date
};

export const isEdiCustomerLocation = (val: Partial<EdiCustomerLocation>): val is EdiCustomerLocation =>
  !!val.customer && !!val.location && !!val.ediType && !!val.mappingId && !!val.partnershipId;

export type EdiCustomerLocation = {
  id?: number;
  customer: Customer;
  location?: Location;
  ediType: 'GATE' | 'LIFT' | 'STATUS';
  mappingId: string;
  partnershipId: string;
  customerCode?: string;
  locationCode?: string;
  fileExtension?: string;
  enabled?: boolean;
};

export enum EDIType {
  GATE = 'GATE',
  LIFT = 'LIFT',
  STATUS = 'STATUS'
}

export interface Customer extends BaseDataType {
  id: number;
  name: string;
  code: string;
  email: string;
  location: Pick<Location, 'id' | 'name' | 'code' | 'state'>;
  deleted: boolean;
  ediRecipients: EdiCustomerLocation[];
  activityReportHours: number[];
  statusReportHours: number[];
  inventoryReportHours: number[];
  interchangeRecipients: string[];
  sendAutomatedReport?: boolean;
  notes?: string;
}

export interface CustomerReportGroup {
  id: number;
  name: string;
  customers: Customer[];
  email: string;
  timezone: string;
  activityReportHours: number[];
  statusReportHours: number[];
  inventoryReportHours: number[];
  sendAutomatedReport?: boolean;
};

export const isReportGroup = (group: Partial<CustomerReportGroup>): group is CustomerReportGroup =>
  !isNaN(group.id ?? NaN) && !!group.name && !!group.customers && !!group.activityReportHours && !!group.statusReportHours && !!group.inventoryReportHours;
